module.exports = __webpack_public_path__ + "img/page2.ea732aee.png";